<template>
  <div class="fill-height">
    <HomePageDesktop v-if="isDesktopView" />
    <HomePageMobile v-if="isMobileView" />
  </div>
</template>

<script>
import HomePageDesktop from '@/components/Views/Home/HomePageDesktop'
import HomePageMobile from '@/components/Views/Home/HomePageMobile'
import sharedComputed from '@/methods/sharedComputed'
import sharedMethods from '@/methods/sharedMethods'

import { createHelpers } from 'vuex-map-fields'
import state from '@/store/state'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'HomePageContainer',

  metaInfo () {
    return this.getMetaTags()
  },

  components: {
    HomePageMobile,
    HomePageDesktop,
  },

  watch: {
    lang () {
      this.setHomeMeta()
    },
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,
  },

  created () {
    if (!this.lang) {
      const lang = this.getLangFromSiteName()
      this.$router.push({ path: '/' + lang })
      this.$i18n.locale = lang
    }
    this.searchObjects()
    this.setHomeMeta()
    this.setContentAreaWidth()
  },

  methods: {
    ...sharedMethods,

    setHomeMeta () {
      this.metaTitle = this.$i18n.t('homeMetaTitle') || this.metaSiteName
      this.metaKeywords = this.$i18n.t('homeMetaKeywords') || ''
      this.metaUrl = this.defaultMetaUrl
      this.metaDescription = this.$i18n.t('homeMetaDescription') || this.defaultMetaDescription
      this.metaImage = this.defaultMetaImage
    },

    getLangFromSiteName () {
      return 'en'
    },
  },
}
</script>
